import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgFolderMove(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.286 14.293a1 1 0 0 1 1.414 0l2.793 2.793A1 1 0 0 1 20.08 18.5l-1.086-1.086V21a1 1 0 0 1-2 0v-3.586L15.907 18.5a1 1 0 1 1-1.414-1.414l2.793-2.793ZM10 3a3 3 0 0 1 3 3v1h6a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H4v9l.005.102A1 1 0 0 0 5 19h6a1 1 0 1 1 0 2H5a3 3 0 0 1-2.996-2.846L2 18V6a3 3 0 0 1 3-3h5ZM5 5a1 1 0 0 0-1 1v1h7V6a1 1 0 0 0-1-1H5Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgFolderMove)
